module.exports = __webpack_public_path__ + "img/Banner_dashboard 1.cbc475c1.svg";